import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactIconButton from 'shared/design-system/components/TrueImpactIconButton';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { faPlus } from '@fortawesome/pro-light-svg-icons';

interface TrueImpactAddButtonProps {
  text: string | JSX.Element;
  maxWidth?: number;
  disabled?: boolean;
  marginTop?: string;
  onClick: () => unknown;
  className?: string;
}

const StyledDiv = styled.div<{
  maxWidth?: number;
  marginTop: string;
  onClick?: () => unknown;
}>`
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth}px` : '')};
  margin-top: ${({ marginTop }) => marginTop};
  margin-left: auto;
  margin-right: auto;
  padding: ${SPACERS.tiny} ${SPACERS.small};
  display: flex;
  align-items: center;
  text-align: left;
  border-radius: 4px;
  border: 1px dashed ${COLORS.ctaPrimary};
  transition: background 0.5s;
  .add-indicator-icon {
    margin-right: ${SPACERS.tiny};
  }
  ${({ onClick }) =>
    onClick
      ? `
    cursor: pointer;
    &:hover {
      background-color: ${COLORS.grayLight};
    }
  `
      : 'cursor: not-allowed;'}
`;

const TrueImpactAddButton: React.FC<TrueImpactAddButtonProps> = ({
  text,
  disabled,
  maxWidth,
  marginTop = SPACERS.large,
  className,
  onClick,
}) => {
  return (
    <StyledDiv
      maxWidth={maxWidth}
      marginTop={marginTop}
      onClick={disabled ? undefined : onClick}
      className={className}
    >
      <TrueImpactIconButton
        icon={faPlus}
        disabled={disabled}
        color="ctaPrimary"
        backgroundColor="ctaPrimaryBackground"
        className="add-indicator-icon"
      />
      <TrueImpactText color="blackPure" variant="body">
        {text}
      </TrueImpactText>
    </StyledDiv>
  );
};

export default TrueImpactAddButton;
